
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/this-is-how-these-four-won-a-holiday-in-lockdown",
      function () {
        return require("private-next-pages/blog/this-is-how-these-four-won-a-holiday-in-lockdown.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/this-is-how-these-four-won-a-holiday-in-lockdown"])
      });
    }
  